import ContractPage from './ContractPage'

export default ContractPage
